import { Check, Compass, MapPin, Search, X } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import type { PublicLocale } from '../../layouts/PublicFrame';
import { loadLandingCities, type LandingCity } from './landingApi';

export function LocationPicker({ open, locale, selectedCity, refreshing, onClose, onSelect, onUseCurrent }: {
  open: boolean;
  locale: PublicLocale;
  selectedCity: string;
  refreshing: boolean;
  onClose: () => void;
  onSelect: (city: LandingCity) => void;
  onUseCurrent: () => Promise<boolean>;
}) {
  const [cities, setCities] = useState<LandingCity[]>([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!open || cities.length) return;
    setLoading(true); setError('');
    loadLandingCities().then(setCities).catch(() => setError('โหลดรายชื่อเมืองไม่สำเร็จ')).finally(() => setLoading(false));
  }, [open, cities.length]);
  const filtered = useMemo(() => {
    const needle = query.trim().toLocaleLowerCase();
    if (!needle) return cities;
    return cities.filter((city) => `${city.name} ${city.name_local}`.toLocaleLowerCase().includes(needle));
  }, [cities, query]);
  if (!open) return null;
  return <div className="location-picker-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className="location-picker" role="dialog" aria-modal="true" aria-labelledby="location-picker-title">
      <header><div><p className="eyebrow">LOCATION</p><h2 id="location-picker-title">เลือกเมือง</h2></div><button className="icon-button" onClick={onClose} aria-label="ปิด"><X /></button></header>
      <div className="location-picker__body">
        <button className="location-picker__current" disabled={refreshing} onClick={async () => { if (await onUseCurrent()) onClose(); }}><Compass /><span><strong>{refreshing ? 'กำลังอ่านตำแหน่ง...' : 'ใช้ตำแหน่งปัจจุบัน'}</strong><small>ค้นหาจังหวัดจากพิกัดของอุปกรณ์</small></span></button>
        <label className="location-picker__search"><Search /><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="ค้นหาเมืองหรือจังหวัด..." /></label>
        {loading && <p className="location-picker__state">กำลังโหลดรายชื่อเมือง...</p>}
        {error && <p className="location-picker__state location-picker__state--error">{error}</p>}
        {!loading && !error && <div className="location-picker__cities">{filtered.map((city) => {
          const selected = city.name.toLocaleLowerCase() === selectedCity.toLocaleLowerCase();
          return <button key={city.id || city.name} className={selected ? 'selected' : ''} onClick={() => { onSelect(city); onClose(); }}><MapPin /><span><strong>{locale === 'th' ? city.name_local : city.name}</strong><small>{locale === 'th' ? city.name : city.name_local}</small></span>{selected && <Check />}</button>;
        })}{filtered.length === 0 && <p className="location-picker__state">ไม่พบเมืองหรือจังหวัด “{query.trim()}”</p>}</div>}
      </div>
    </section>
  </div>;
}
